import { AppDrawer } from "@/components/AppDrawer";
import { DrawerProvider, useDrawer } from "@/contexts/drawer-context";
import { usePullToRefresh } from "@/hooks/use-pull-to-refresh";
import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { Toaster } from "sonner";

type RouterContext = {
  queryClient: QueryClient;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  usePullToRefresh();

  return (
    <DrawerProvider>
      <div className="mx-auto flex h-dvh max-w-md flex-col overflow-hidden bg-background">
        <Outlet />
        <Toaster position="top-center" />
        <DrawerContainer />
      </div>
    </DrawerProvider>
  );
}

/** DrawerProvider 内から useDrawer を呼ぶためのラッパー */
const DrawerContainer = () => {
  const { isOpen, close } = useDrawer();
  return <AppDrawer open={isOpen} onClose={close} />;
};
